import {Directive, HostListener, Input} from '@angular/core';
import {XlsxExportOptions} from './interface';
import {XlsxService} from './xlsx.service';

@Directive({
  selector: '[jdXlsx], [jd-xlsx]'
})
export class XlsxDirective {
  @Input('xlsx') data: XlsxExportOptions;

  constructor(private srv: XlsxService) {
  }

  @HostListener('click')
  _click() {
    this.srv.export(this.data);
  }
}
